export enum ReportPermission {
  COPY = 'Dashboard.copy',
  DELETE = 'Dashboard.destroy',
  SHARE = 'Dashboard.share_by_email',
  SHOW = 'Dashboard.show',
  UPDATE = 'Dashboard.update',
}
